import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './Layouts/Layout';
import Home from './pages/Home';
import WhoWeAre from './pages/WhoWeAre';
import BailApplication from './pages/Services/BailApplication';
import DrugCharges from './pages/Services/DrugCharges';
import SexualOffences from './pages/Services/SexualOffences';
import TheftFraud from './pages/Services/TheftFraud';
import AssaultPropertyDamage from './pages/Services/AssaultPropertyDamage';
import TrafficDrinkDriving from './pages/Services/TrafficDrinkDriving';
import InterventionOrdersDomesticViolence from './pages/Services/InterventionOrdersDomesticViolence';
import ChildrensCourtMatters from './pages/Services/ChildrensCourtMatters';
import CommonwealthCriminalMatters from './pages/Services/CommonwealthCriminalMatters';
import ServiceCategory from './pages/ServiceCategory';
import Divorce from './pages/Services/Divorce';
import CivilLitigation from './pages/Services/CivilLitigation';
import CommercialLitigation from './pages/Services/CommercialLitigation';
import Immigration from './pages/Services/Immigration';
import PropertySettlement from './pages/Services/PropertySettlement';
import ParentingMatters from './pages/Services/ParentingMatters';


function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<WhoWeAre />} />
          <Route path="/services/criminal" element={<ServiceCategory category="Criminal Law" />} />
          <Route path="/services/criminal/bail-application" element={<BailApplication />} />
          <Route path="/services/criminal/drug-charges" element={<DrugCharges />} />
          <Route path="/services/criminal/sexual-offences" element={<SexualOffences />} />
          <Route path="/services/criminal/theft-fraud" element={<TheftFraud />} />
          <Route path="/services/criminal/assault-property-damage" element={<AssaultPropertyDamage />} />
          <Route path="/services/criminal/traffic" element={<TrafficDrinkDriving />} />
          <Route path="/services/criminal/intervention-domestic" element={<InterventionOrdersDomesticViolence />} />
          <Route path="/services/criminal/childrens-court" element={<ChildrensCourtMatters />} />
          <Route path="/services/criminal/commonwealth" element={<CommonwealthCriminalMatters />} />
          <Route path="/services/family" element={<ServiceCategory category="Family Law" />} />
          <Route path="/services/family/divorce" element={<Divorce />} />
          <Route path="/services/family/property-settlement" element={<PropertySettlement />} />
          <Route path="/services/family/parenting-matters" element={<ParentingMatters />} />
          <Route path="/services/civil-commercial" element={<ServiceCategory category="Civil & Commercial Litigation" />} />
          <Route path="/services/civil-commercial/civil-litigation" element={<CivilLitigation />} />
          <Route path="/services/civil-commercial/commercial-litigation" element={<CommercialLitigation />} />
          <Route path="/services/immigration" element={<ServiceCategory category="Immigration Law" />} />
          <Route path="/services/immigration/immigration" element={<Immigration />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
